import api from '../api';

export async function getUserCancel(id) {
  try {
    const { data } = await api.get(`usuario/usuario-ou-gestor/${id}`);

    return data;
  } catch (error) {
    return null;
  }
}
